import { Sprite, _decorator } from 'cc';
import { RoadmapItemData, RoadmapItemType } from '../../../Data/Strategy/RoadmapLayout/BaseRoadmapLayoutStrategy';
import BasicRoadmapLayoutStrategy from '../../../Data/Strategy/RoadmapLayout/BasicRoadmapLayoutStrategy';
import RoadmapItem from './RoadmapItem';

const { ccclass, requireComponent } = _decorator;

@ccclass('EnterMachineRoadmapItem')
@requireComponent(Sprite)
export default class EnterMachineRoadmapItem extends RoadmapItem {
    private _sprite: Sprite = null;

    protected get sprite() {
        if (!this._sprite) {
            this._sprite = this.getComponent(Sprite);
        }
        return this._sprite;
    }

    public display(data: RoadmapItemData) {
        super.display(data);

        // update sprite fill range
        if (data.type === RoadmapItemType.CURRENT) {
            let progress = (data.spinResults.length % BasicRoadmapLayoutStrategy.SPIN_COUNT_PER_ITEM) / BasicRoadmapLayoutStrategy.SPIN_COUNT_PER_ITEM;
            if (progress === 0 && data.spinResults.length > 0) {
                progress = 1;
            }
            this.sprite.fillRange = -progress;
        } else {
            this.sprite.fillRange = -1;
        }

        this.node.angle = data.expanded ? 90 : 0;
    }
}
